<div fxLayout="column">
    <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
    <div *ngIf="isBrowserIE; else paymentFormFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="paymentFormFlexColumnTemplate"></ng-container>
    </div>
</div>

<ng-template #paymentFormFlexColumnTemplate>
    <div fxLayout="column">
        <div class="display-text normal-paragraph-spacing" style="text-align: center" *ngIf="showSpinner">
            <mat-spinner color="accent" diameter="32"></mat-spinner>
        </div>
        <div fxLayout="column" *ngIf="!showSpinner">
            <div *ngIf="isBrowserIE; else paymentFormMainFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
                <ng-container *ngTemplateOutlet="paymentFormMainFlexColumnTemplate"></ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #paymentFormMainFlexColumnTemplate>
    <div fxFlex="100%" class="display-text normal-paragraph-spacing" *ngIf="CompanyCode_Check()">
        <b><span i18n="@@payment-form.main.top-statement">payment-form.main.top-statement</span></b>
    </div>
    <div fxFlex="100%" class="display-text normal-paragraph-spacing" *ngIf="!CompanyCode_Check()">
        <b><span i18n="@@payment-form.main.top-statement-A">payment-form.main.top-statement-A</span></b>
    </div>
    <div fxFlex="100%" fxLayout="row" *ngIf="paymentAddressFound">
        <div *ngIf="isBrowserIE && media.isActive('lt-md'); else paymentFormFormFlexColumnTemplate">
            <ng-container *ngTemplateOutlet="paymentFormFormFlexColumnTemplate"></ng-container>
        </div>
    </div>
    <!--10/07/2021 RA - Added new Legal Text -->
    <div fxFlex="100%" fxLayout="row">
        <div *ngIf="isBrowserIE; else paymentFormLegalFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
            <ng-container *ngTemplateOutlet="paymentFormLegalFlexColumnTemplate"></ng-container>
        </div>
    </div>
    <div fxFlex="100%" fxLayout="row" *ngIf="paymentAddressFound">
        <div *ngIf="isBrowserIE && media.isActive('lt-md'); else paymentFormOptionsFlexColumnTemplate">
            <ng-container *ngTemplateOutlet="paymentFormOptionsFlexColumnTemplate"></ng-container>
        </div>
    </div>
    <div fxLayout="column" *ngIf="paymentAddressFound">
        <div *ngIf="isBrowserIE && media.isActive('lt-md'); else paymentFormNoticesFlexColumnTemplate"
            [ngClass]="{ 'ie-display': isBrowserIE }">
            <ng-container *ngTemplateOutlet="paymentFormNoticesFlexColumnTemplate"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #paymentFormFormFlexColumnTemplate>
    <div fxFlex="100%">
        <form [formGroup]="paymentForm">
            <div fxLayout="column">
                <div fxLayout="row" fxLayoutAlign="center center"
                    class="display-text normal-paragraph-spacing highlighted-display-text">
                    <b><span i18n="@@payment-form.form.title">payment-form.form.title</span></b>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                    <mat-form-field fxFlex="40%" fxFlex.lt-md="100%">
                        <input matInput i18n-placeholder="@@payment-form.form.participant-id.label"
                            placeholder="payment-form.form.participant-id.label" type="text" [value]="participantId"
                            autocomplete="off" readonly />
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                    <mat-form-field fxFlex="40%" fxFlex.lt-md="100%">
                        <textarea matInput
                            cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="1"
                            cdkAutosizeMaxRows="5"

                            i18n-placeholder="@@payment-form.form.note-ids.label"
                            placeholder="payment-form.form.note-ids.label"
                            [value]="noteIds.join(', ') "
                            autocomplete="off" readonly
                            style="white-space: pre-wrap; word-break: break-word; overflow-wrap: break-word;height: auto;
        line-height: 1.2em;"></textarea>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                    <mat-form-field fxFlex="40%" fxFlex.lt-md="100%">
                        <input matInput i18n-placeholder="@@payment-form.form.name.label"
                            placeholder="payment-form.form.name.label" type="text" [formControl]="nameFormControl"
                            autocomplete="off" [maxlength]="fieldValidations.payment.nameMaxLength" required />
                        <mat-error class="form-error" *ngIf="nameFormControl.hasError('required')"
                            i18n="@@payment-form.form.error.required">payment-form.form.error.required</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                    <mat-form-field fxFlex="40%" fxFlex.lt-md="100%">
                        <input matInput i18n-placeholder="@@payment-form.form.address1.label"
                            placeholder="payment-form.form.address1.label" type="text"
                            [formControl]="addressLine1FormControl" autocomplete="off"
                            [maxlength]="fieldValidations.payment.addressLine1MaxLength" required />
                        <mat-error class="form-error" *ngIf="addressLine1FormControl.hasError('required')"
                            i18n="@@payment-form.form.error.required">payment-form.form.error.required</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                    <mat-form-field fxFlex="40%" fxFlex.lt-md="100%">
                        <input matInput i18n-placeholder="@@payment-form.form.address2.label"
                            placeholder="payment-form.form.address2.label" type="text"
                            [formControl]="addressLine2FormControl" autocomplete="off"
                            [maxlength]="fieldValidations.payment.addressLine2MaxLength" />
                        <mat-error class="form-error" *ngIf="addressLine2FormControl.hasError('required')"
                            i18n="@@payment-form.form.error.required">payment-form.form.error.required</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                    <mat-form-field fxFlex="30%" fxFlex.lt-md="100%">
                        <input matInput i18n-placeholder="@@payment-form.form.city.label"
                            placeholder="payment-form.form.city.label" type="text" [formControl]="cityFormControl"
                            autocomplete="off" [maxlength]="fieldValidations.payment.cityMaxLength" required />
                        <mat-error class="form-error" *ngIf="cityFormControl.hasError('required')"
                            i18n="@@payment-form.form.error.required">payment-form.form.error.required</mat-error>
                    </mat-form-field>
                    <span fxFlex="10%" fxHide.lt-md></span>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                    <mat-form-field fxFlex="20%" fxFlex.lt-md="100%">
                        <mat-select *ngIf="allowPaymentInfoEdit" i18n-placeholder="@@payment-form.form.country.label"
                            placeholder="payment-form.form.country.label" [formControl]="countryFormControl"
                            autocomplete="off" required>
                            <mat-option *ngFor="let country of countryList" value="{{ country.countryCode }}">{{
                                country.countryDescription }}</mat-option>
                        </mat-select>
                        <mat-select *ngIf="!allowPaymentInfoEdit" i18n-placeholder="@@payment-form.form.country.label"
                            placeholder="payment-form.form.country.label" [formControl]="countryFormControl"
                            autocomplete="off" required>
                            <mat-option *ngFor="let country of countryList" value="{{ country.countryCode }}">{{
                                country.countryDescription }}</mat-option>
                        </mat-select>
                        <mat-error class="form-error" *ngIf="countryFormControl.hasError('required')"
                            i18n="@@payment-form.form.error.required">payment-form.form.error.required</mat-error>
                    </mat-form-field>
                    <span fxFlex="20%" fxHide.lt-md></span>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                    <mat-form-field fxFlex="20%" fxFlex.lt-md="100%">
                        <mat-select i18n-placeholder="@@payment-form.form.state.label"
                            placeholder="payment-form.form.state.label" [formControl]="stateFormControl"
                            autocomplete="off" required>
                            <mat-option *ngFor="let state of stateList" value="{{ state.stateCode }}">{{
                                state.stateDescription }}</mat-option>
                        </mat-select>
                        <mat-error class="form-error" *ngIf="stateFormControl.hasError('required')"
                            i18n="@@payment-form.form.error.required">payment-form.form.error.required</mat-error>
                    </mat-form-field>
                    <span fxFlex="20%" fxHide.lt-md></span>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                    <mat-form-field fxFlex="20%" fxFlex.lt-md="100%">
                        <!-- 03/30/2021 RA - two input statements - one for zip code with only numbers, one that allows both numbers and letters -->
                        <input matInput i18n-placeholder="@@payment-form.form.zip-code.label"
                            placeholder="payment-form.form.zip-code.label" type="text"
                            [formControl]="zipCodeFormControl" autocomplete="postal-code"
                            [minLength]="getPaymentZipCodeMinLength(paymentForm.get('countryFormControl').value)"
                            [maxlength]="getPaymentZipCodeMaxLength(paymentForm.get('countryFormControl').value)"
                            *ngIf="!PaymentZipCodeOnlyAllowsNumbers()" />
                        <!-- required 03/30/2021 RA - Removed required as we are doing it programmatically -->
                        <input matInput i18n-placeholder="@@payment-form.form.zip-code.label"
                            placeholder="payment-form.form.zip-code.label" type="text"
                            [formControl]="zipCodeFormControl" autocomplete="postal-code"
                            [minLength]="getPaymentZipCodeMinLength(paymentForm.get('countryFormControl').value)"
                            [maxlength]="getPaymentZipCodeMaxLength(paymentForm.get('countryFormControl').value)"
                            onkeypress="return isNumberKey(this, event, 0)" *ngIf="PaymentZipCodeOnlyAllowsNumbers()" />
                        <!--required 03/30/2021 RA - Removed required as we are doing it programmatically -->
                        <mat-error class="form-error" *ngIf="zipCodeFormControl.hasError('required')"
                            i18n="@@payment-form.form.error.required">payment-form.form.error.required</mat-error>
                        <!-- 03/30/2021 RA - Added country to error check as to not show multiple error statements -->
                        <mat-error *ngIf="((zipCodeFormControl.hasError('minlength') || zipCodeFormControl.hasError('maxlength') ||
                       zipCodeFormControl.hasError('pattern') || zipCodeFormControl.hasError('required')) &&
                      paymentForm.get('countryFormControl').value === 'USA')"
                            i18n="@@payment-form.form.zip-code.error-USA">payment-form.form.error.zip-code</mat-error>
                        <!-- 03/30/2021 RA - Added Canadian error message for invalid Zip Code pattern and check country -->
                        <mat-error *ngIf="((zipCodeFormControl.hasError('minlength') || zipCodeFormControl.hasError('maxlength') ||
                       zipCodeFormControl.hasError('pattern') || zipCodeFormControl.hasError('required')) &&
                       paymentForm.get('countryFormControl').value === 'CAN')"
                            i18n="@@payment-form.form.zip-code.error-CAN">payment-form.form.error.zip-code</mat-error>
                        <!-- 03/30/2021 RA - Added Foreign error message for invalid Zip Code pattern and check country -->
                        <mat-error *ngIf="((zipCodeFormControl.hasError('minlength') || zipCodeFormControl.hasError('maxlength') ||
                     zipCodeFormControl.hasError('pattern')) && paymentForm.get('countryFormControl').value === 'FOR')"
                            i18n="@@payment-form.form.zip-code.error-FOR">payment-form.form.error.zip-code</mat-error>
                    </mat-form-field>
                    <mat-form-field fxFlex="20%" fxFlex.lt-md="100%" *ngIf="allowPaymentInfoEdit">
                        <input matInput i18n-placeholder="@@payment-form.form.zip-code.label"
                            placeholder="payment-form.form.zip-code.label" type="text" [value]="paymentAddress.zipCode"
                            autocomplete="off" />
                    </mat-form-field>
                    <span fxFlex="20%" fxHide.lt-md></span>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                    <mat-form-field fxFlex="40%" fxFlex.lt-md="100%">
                        <input matInput i18n-placeholder="@@payment-form.form.payment-amount.label"
                            placeholder="payment-form.form.payment-amount.label" type="text"
                            [value]="paymentAmount.toFixed(2)" autocomplete="off" readonly />
                        <span matPrefix>$&nbsp;</span>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center"
                    class="display-text normal-paragraph-spacing warning-color">
                    <b><span i18n="@@payment-form.form.warning">payment-form.form.warning</span></b>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                    <h3 class="section-header">Select Payment Method</h3>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center">
                    <ng-container *ngTemplateOutlet="paymentAlternativePaymentsTemplate"></ng-container>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center">

                    <!-- PAYMENT SELECTION SECTION -->
                    <div class="payment-methods-section">

                        <mat-radio-group class="payment-radio-group" [formControl]="paymentTypeFormControl">
                            <!-- Credit Card Option -->
                            <mat-radio-button class="form-radio-button" [value]="paymentType.CreditCard"
                                *ngIf="paymentAddress.acceptCreditCardFlag" matTooltip="Pay with Credit/Debit Card">
                                <div class="image-container">
                                    <img src="../assets/visa_dark.png" alt="Visa" />
                                    <img src="../assets/mastercard_dark.png" alt="MasterCard" />
                                    <img src="../assets/amex_dark.png" alt="American Express" />
                                    <img src="../assets/discover_dark.png" alt="Discover" />
                                </div>
                            </mat-radio-button>

                            <!-- eCheck Option -->
                            <mat-radio-button class="form-radio-button" [value]="paymentType.ElectronicCheck"
                                *ngIf="paymentAddress.acceptCreditCardFlag" matTooltip="Pay with Electronic Check">
                                <img src="../assets/echeck.png" alt="eCheck" class="echeck-image" />
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>

                </div>
                <!-- Need to show Braintree loading of dropdowns and ready state -->
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text"
                    *ngIf="isPaymentTypeCreditCard()">
                    <mat-spinner color="accent" diameter="32" *ngIf="showBraintreeSpinner"></mat-spinner>
                </div>
                <!-- Credit Card Form -->
                <div fxLayout="row wrap" fxFlex="40%" fxFlex.lt-md="100%" fxLayoutAlign="center center" class="display-text field-container"
                    *ngIf="isPaymentTypeCreditCard()">
                    <div fxFlex="25%" fxFlex.lt-md="100%" class="textfield--float-label">
                        <label class="hosted-field--label" for="credit-card-number">Credit Card
                            Number<sup>*</sup></label>
                        <div id="credit-card-number" class="hosted-field"></div>
                        <div id="credit-card-number-error" class="error-message"></div>
                    </div>
                    <div fxFlex="5%" class="textfield--float-label"></div>
                    <div fxFlex="10%" fxFlex.lt-md="100%" class="textfield--float-label">
                        <label class="hosted-field--label" for="cvv">CVV<sup>*</sup></label>
                        <div id="cvv" class="hosted-field"></div>
                        <div id="cvv-error" class="error-message"></div>
                    </div>
                </div>
                <div fxLayout="row wrap" fxFlex="40%" fxFlex.lt-md="100%" fxLayoutAlign="center center" class="display-text"
                    *ngIf="isPaymentTypeCreditCard()">
                    <div fxFlex="25%" fxFlex.lt-md="100%"  class="textfield-exp--label">
                        <label class="hosted-exp-field--label" for="expiration-month">Exp Month<sup>*</sup></label>
                        <div id="expiration-month" class="hosted-field"></div>
                    </div>
                    <div fxFlex="5%" class="textfield--float-label"></div>
                    <div fxFlex="10%" fxFlex.lt-md="100%" class="textfield-exp-year-label textfield-exp--label">
                        <label class="hosted-exp-field--label" for="expiration-year">Exp Year<sup>*</sup></label>
                        <div id="expiration-year" class="hosted-field"></div>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text field-container"
                    *ngIf="isPaymentTypeCreditCard()">
                    <div fxFlex="25%" fxFlex.lt-md="100%" class="textfield--float-label">
                        <div id="expiration-date-error" class="error-exp-date-message"></div>
                    </div>
                </div>
                <!-- <div fxLayout="row" class="display-text field-container"
                    *ngIf="isPaymentTypeCreditCard()">
                    <div class="textfield--float-label">
                        <label class="hosted-field--label" for="cvv">CVV<sup>*</sup></label>
                        <div id="cvv" class="hosted-field"></div>
                        <div id="cvv-error" class="error-message"></div>
                    </div>
                    <div></div>
                </div> -->
                <!-- ACH Form -->
                <div fxLayout="row wrap" fxFlex="40%" fxFlex.lt-md="100%" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing"
                    *ngIf="!isPaymentTypeCreditCard()">
                    <mat-radio-group
                        class="form-radio-group display-text" [formControl]="bankAccountTypeFormControl">
                        <mat-radio-button class="form-radio-button" [value]="bankAccountType.Checking"><span
                                i18n="@@payment-form.form.bank-account-type.checking.label">payment-form.form.bank-account-type.checking.label</span></mat-radio-button>
                        <mat-radio-button class="form-radio-button" [value]="bankAccountType.Savings"><span
                                i18n="@@payment-form.form.bank-account-type.savings.label">payment-form.form.bank-account-type.savings.label</span></mat-radio-button>
                    </mat-radio-group>
                </div>
                <div fxLayout="row wrap" fxFlex="40%" fxFlex.lt-md="100%" fxLayoutAlign="center center" class="display-text"
                    *ngIf="!isPaymentTypeCreditCard()">
                    <mat-form-field fxFlex="40%" fxFlex.lt-md="100%">
                        <input matInput i18n-placeholder="@@payment-form.form.bank-routing-number.label"
                            placeholder="payment-form.form.bank-routing-number.label" type="text"
                            [formControl]="bankRoutingNumberFormControl" autocomplete="off"
                            [minLength]="fieldValidations.payment.bank.bankRoutingNumberMinLength"
                            [maxlength]="fieldValidations.payment.bank.bankRoutingNumberMaxLength"
                            onkeypress="return isNumberKey(this, event, 0)" required onCopy="return false"
                            onDrag="return false" onDrop="return false" onPaste="return false" />
                        <mat-error class="form-error" *ngIf="bankRoutingNumberFormControl.hasError('required')"
                            i18n="@@payment-form.form.error.required">payment-form.form.error.required</mat-error>
                        <mat-error class="form-error" *ngIf="
                (bankRoutingNumberFormControl.hasError('minlength') || bankRoutingNumberFormControl.hasError('maxlength')) &&
                !bankRoutingNumberFormControl.hasError('required')
              " i18n="@@payment-form.form.bank-routing-number.error">payment-form.form.bank-routing-number.error</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row wrap" fxFlex="40%" fxFlex.lt-md="100%" fxLayoutAlign="center center" class="display-text"
                    *ngIf="!isPaymentTypeCreditCard()">
                    <mat-form-field fxFlex="40%" fxFlex.lt-md="100%">
                        <input matInput i18n-placeholder="@@payment-form.form.bank-account-number.label"
                            placeholder="payment-form.form.bank-account-number.label" type="text"
                            [formControl]="bankAccountNumberFormControl" autocomplete="off"
                            [minLength]="fieldValidations.payment.bank.bankAccountNumberMinLength"
                            [maxlength]="fieldValidations.payment.bank.bankAccountNumberMaxLength"
                            onkeypress="return isNumberKey(this, event, 0)" required onCopy="return false"
                            onDrag="return false" onDrop="return false" onPaste="return false" />
                        <mat-error class="form-error" *ngIf="bankAccountNumberFormControl.hasError('required')"
                            i18n="@@payment-form.form.error.required">payment-form.form.error.required</mat-error>
                        <mat-error class="form-error" *ngIf="
                (bankAccountNumberFormControl.hasError('minlength') || bankAccountNumberFormControl.hasError('maxlength')) &&
                !bankAccountNumberFormControl.hasError('required')
              " i18n="@@payment-form.form.bank-account-number.error">payment-form.form.bank-account-number.error</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row wrap" fxFlex="40%" fxFlex.lt-md="100%" fxLayoutAlign="center center" class="display-text"
                    *ngIf="!isPaymentTypeCreditCard()">
                    <mat-form-field fxFlex="40%" fxFlex.lt-md="100%">
                        <input matInput i18n-placeholder="@@payment-form.form.bank-account-number-confirm.label"
                            placeholder="payment-form.form.bank-account-number-confirm.label" type="text"
                            [formControl]="bankAccountNumberConfirmFormControl" autocomplete="off"
                            [minLength]="fieldValidations.payment.bank.bankAccountNumberMinLength"
                            [maxlength]="fieldValidations.payment.bank.bankAccountNumberMaxLength"
                            onkeypress="return isNumberKey(this, event, 0)" required onCopy="return false"
                            onDrag="return false" onDrop="return false" onPaste="return false" />
                        <mat-error class="form-error" *ngIf="bankAccountNumberConfirmFormControl.hasError('required')"
                            i18n="@@payment-form.form.error.required">payment-form.form.error.required</mat-error>
                        <mat-error class="form-error" *ngIf="
                (bankAccountNumberConfirmFormControl.hasError('minlength') || bankAccountNumberConfirmFormControl.hasError('maxlength')) &&
                !bankAccountNumberConfirmFormControl.hasError('required')
              " i18n="@@payment-form.form.bank-account-number-confirm.error">payment-form.form.bank-account-number-confirm.error</mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center"
                    class="display-text form-error-display-text normal-paragraph-spacing"
                    *ngIf="!isPaymentTypeCreditCard()">
                    <span fxFlex="25%" fxFlex.lt-md="100%" fxLayoutAlign="left start">
                        <mat-error class="form-error"
                            *ngIf="bankAccountNumberEqualsFormControl.invalid && !bankAccountNumberConfirmFormControl.hasError('required')"
                            i18n="@@payment-form.form.bank-account-number-confirm-equals.error">payment-form.form.bank-account-number-confirm-equals.error</mat-error>
                        <!-- the following is used as a spacer so the screen does not shift-->
                        <mat-error class="form-error"
                            *ngIf="!(bankAccountNumberEqualsFormControl.invalid && !bankAccountNumberConfirmFormControl.hasError('required'))">&nbsp;</mat-error>
                    </span>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center"
                    class="display-text normal-paragraph-pre-spacing normal-paragraph-spacing"
                    *ngIf="!isPaymentTypeCreditCard()">
                    
                    <img src="../assets/ach_example_check.jpg" style="max-width: 100%; height: auto;" alt="ACH Example Check" />
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing"
                    *ngIf="!isPaymentTypeCreditCard()">
                    <span
                        i18n="@@payment-form.form.bank-account-info.not-found-statement">payment-form.form.bank-account-info.not-found-statement</span>
                </div>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #paymentFormNoticesFlexColumnTemplate>
    <div class="display-text"><sup>*</sup>&nbsp;<span i18n="@@payment-form.notices.1">payment-form.notices.1</span>
    </div>
    <div class="display-text"><span i18n="@@payment-form.notices.2">payment-form.notices.2</span></div>
</ng-template>

<ng-template #paymentFormOptionsFlexColumnTemplate>
    <div fxLayout="row" fxFlex="100%" style="margin: 20px 0;" class="display-text" fxLayoutAlign="center center">
        <button #SubmitButton mat-flat-button color="primary" (click)="submitPayment()" [disabled]="isFormValid()"
            i18n="@@payment-form.form.submit-button.label">
            payment-form.form.submit-button.label</button>&nbsp;&nbsp;
        <button mat-stroked-button color="primary" (click)="cancelPayment()"
            i18n="@@payment-form.form.cancel-button.label">
            payment-form.form.cancel-button.label
        </button>
    </div>
</ng-template>

<ng-template #paymentAlternativePaymentsTemplate>
    <div fxLayout="row" fxLayoutAlign="center" class="display-text">

        <!-- ALTERNATE PAYMENT OPTIONS -->
        <div class="alt-payments-section">
            <div *ngIf="browserSupportsApplePay" id="apple-pay-button" class="apple-pay-button apple-pay-button-black pay-button" matTooltip="Pay with Apple Pay"></div>
            <div id="google-pay-button" class="googlePayContainer pay-button" matTooltip="Pay with Google Pay">
            </div>
            <!-- <div id="paypal-button" class="pay-button" matTooltip="Pay with PayPal"></div> -->
        </div>

    </div>
</ng-template>